import { render, staticRenderFns } from "./serviceSheetDetail.vue?vue&type=template&id=694d2221&scoped=true"
import script from "./serviceSheetDetail.vue?vue&type=script&lang=js"
export * from "./serviceSheetDetail.vue?vue&type=script&lang=js"
import style0 from "./serviceSheetDetail.vue?vue&type=style&index=0&id=694d2221&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "694d2221",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('694d2221')) {
      api.createRecord('694d2221', component.options)
    } else {
      api.reload('694d2221', component.options)
    }
    module.hot.accept("./serviceSheetDetail.vue?vue&type=template&id=694d2221&scoped=true", function () {
      api.rerender('694d2221', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/serviceSheetDetail.vue"
export default component.exports